import {effect} from 'utils/redux';
import namespace from './namespace';

const creator = effect(namespace);

export let initialize = () => (getState, dispatch) => {};
initialize = creator('initialize', initialize);
